import { SsoAccountData } from '../../../../../sso-account/domain/models/sso-account.model';
import { DeviceData } from '../../../../../../../lib/device/device-detection.model';
import { IdVerseFailedAction } from '../../../../domain/models/identity-verification.model';

export enum IdVerseFlowType {
  MobileAppPromo = 'mobile-app-promo',
  StandardPendingFlow = 'standard-pending-flow',
  MobileSyncing = 'mobile-syncing',
  Success = 'success',
  Failed = 'failed',
}

export interface IdVerseContentConfig {
  showMobileAppPromo: boolean;
}

export interface IdVerseViewState {
  currentFlowType: IdVerseFlowType;
  verificationUrl: string;
  skipMobileAppPromo: boolean;
  failedAction: IdVerseFailedAction | null;
}

export interface IdVerseViewData {
  state: IdVerseViewState;
  logoUrl: string;
  qrLogoUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
  mobileDownloadUrl: string;
  deviceData: DeviceData;
  currentSsoAccount: SsoAccountData;
  customerName: string;
}
